import { Card } from '@mantine/core';
import { Calendar1, CalendarDays } from 'lucide-react';
import { FC } from 'react';

import { useCalendarStore } from '@/stores/calendarStore.ts';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    handleToggle: () => void;
}

const CalendarTypeSelector: FC<Props> = ({ handleToggle }) => {
    const is_week_view_enabled = useCalendarStore((state) => state.is_week_view_enabled);

    return (
        <Card classNames={{ root: 'p-0' }} onClick={handleToggle} className="relative cursor-pointer">
            <div className="flex h-10 w-[120px] items-center rounded-full border border-gray-200 bg-white p-1">
                <div
                    className={cn(
                        'absolute h-8 w-[55px] rounded-full bg-primary transition-transform duration-300 ease-in-out',
                        is_week_view_enabled ? 'translate-x-full' : 'translate-x-0'
                    )}
                />

                <div className="relative z-10 flex h-8 w-[50%] items-center justify-center rounded-full">
                    <Calendar1 className="size-5" />
                </div>
                <div className="relative z-10 flex h-8 w-[50%] items-center justify-center rounded-full">
                    <CalendarDays className="size-5" />
                </div>
            </div>
        </Card>
    );
};

export default CalendarTypeSelector;
